import { SkillBase } from '../../../../models/@competentNL/Skills/Skills';
import { OccupationDetail, OccupationSkill } from '../../../../models/OccupationDetail/OccupationDetail';

export interface ComparedOccupationSkills {
    matchedEssential: OccupationSkill[];
    notMatchedEssential: OccupationSkill[];
    matchedOptional: OccupationSkill[];
    notMatchedOptional: OccupationSkill[];
}

const defaultComparedOccupationSkills = (): ComparedOccupationSkills => ({
    matchedEssential: [],
    notMatchedEssential: [],
    matchedOptional: [],
    notMatchedOptional: [],
});

export const getComparedOccupationSkills = (occupation: OccupationDetail, skills: SkillBase[]): ComparedOccupationSkills => {
    if (skills.length === 0) return defaultComparedOccupationSkills();

    const skillIds = skills.map(skill => skill.id);

    const matchedEssential = occupation.essentialSkills.filter(skill => skillIds.includes(skill.id));
    const notMatchedEssential = occupation.essentialSkills.filter(skill => !matchedEssential.includes(skill));
    const matchedOptional = occupation.optionalSkills.filter(skill => skillIds.includes(skill.id));
    const notMatchedOptional = occupation.optionalSkills.filter(skill => !matchedOptional.includes(skill));

    return {
        matchedEssential,
        notMatchedEssential,
        matchedOptional,
        notMatchedOptional,
    };
};
